import MuiTabContext from "@mui/lab/TabContext";
const TabContext = MuiTabContext;
export default TabContext;
